import React from "react";
import App from "./App";
import About from "./About";
import Policy from "./Policy";
import {
    HashRouter as Router,
    Switch,
    Route
} from "react-router-dom";

export default function BasicExample() {
    return (
        <Router>
            <Switch>
                <Route exact path="/" component={App}/>
                <Route path="/about" component={About}/>
                <Route path="/policy" component={Policy}/>
                <Route exact path="/commands" component={App}/>
                <Route path="/category/:categoryName" component={App}/>
            </Switch>
        </Router>
    );
}